import { createContext } from "react";
/**
 * Context for visible layout
 *
 * Can be used to access the visible layout, if any component needs the complete layout state
 */
export const VisibleLayoutContext = createContext({
    id: "",
    rows: [],
    version: -1,
});
VisibleLayoutContext.displayName = "VisibleLayoutContext";
//# sourceMappingURL=VisibleLayoutContext.js.map